import { css } from '@emotion/react'

import InformationIcon from '../icons/InformationIcon'
import WarningIcon from '../icons/WarningIcon'
import Colors from '../theme/Colors'

export default function Notification(props: {
  type: 'error' | 'warning'
  message: string | React.ReactNode
}) {
  const renderIcon = () => {
    if (props.type === 'error') {
      return <WarningIcon />
    }

    return <InformationIcon />
  }

  return (
    <div
      css={css`
        display: flex;
        border-radius: 5px 5px 0 0;
        color: ${Colors.Red400};
        font-size: 16px;
        margin: -20px -20px 20px;
        border-bottom: solid 1px ${Colors.Gray50};
        width: 100%;
        padding: 15px 20px;

        ${props.type === 'warning' &&
        `
        background: ${Colors.EggShell};
        color: ${Colors.Gray600};
        `}
      `}
    >
      {renderIcon()}

      <div
        css={css`
          font-size: 14px;
          line-height: 17px;
          display: inline-block;
          margin-left: 10px;
        `}
      >
        {props.message}
      </div>
    </div>
  )
}
